import { ReactNode } from 'react';

import ChainIcon from '@/icons/ChainIcon.svg?react';

export interface HubCardProps {
  icon?: ReactNode;
  title?: ReactNode;
  className?: string;
  actions?: ReactNode;
  children?: ReactNode;
}

export function HubCard(props: HubCardProps) {
  return (
    <div className="flex flex-col rounded-lg border border-secondary bg-background">
      <div className="flex flex-wrap items-center gap-4 border-b border-secondary p-4">
        <div className="shrink-0 rounded-md bg-brand-tertiary p-1.5 text-brand-green-400">
          {props.icon ?? <ChainIcon />}
        </div>
        <div className="flex-grow text-lg font-semibold text-ls-black">
          {props.title}
        </div>
        <div className="flex flex-shrink-0 items-center gap-2">
          {props.actions}
        </div>
      </div>
      <div className="p-4">{props.children}</div>
    </div>
  );
}
